// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_2Eg4A","container":"index_container_3Mbyl","footerNav":"index_footerNav_3f7NL"};